import classNames from 'classnames';
import { startCase, toLower } from 'lodash';
import { FC, ReactNode } from 'react';

import { IconEdit } from 'src/general/Icons/IconEdit';
import { ButtonIcon } from 'src/general/components/Button/ButtonIcon';
import { LocationObject } from 'src/general/components/SetLocationPopup/EnterLocationScreen/SetLocation/SetLocation.types';

import styles from './EditLocation.module.scss';

export type EditLocationProps = {
  onEdit: () => void;
  location: LocationObject;
  locationHeader: ReactNode;
  locationFooter: ReactNode;
  emailInput: ReactNode;
};

export const EditLocation: FC<EditLocationProps> = ({
  onEdit,
  location,
  locationHeader,
  locationFooter,
  emailInput,
}) => (
  <div className={styles.container}>
    <div className={styles.content}>
      <div className={styles.textWrapper}>
        <span className={classNames(styles.bold, styles.text)}>{locationHeader}</span>
        <span className={styles.text}>{`${startCase(toLower(location.name))} ${location.post_code} ${
          location.state
        }`}</span>
      </div>
      <ButtonIcon
        className={styles.edit}
        title="Edit"
        Icon={IconEdit}
        onClick={onEdit}
        data-testid="EditLocation-button"
      />
    </div>
    {location.can_pickup && (
      <>
        <span className={styles.descriptionMobile}>{locationFooter}</span>
        {!location.can_deliver && emailInput}
      </>
    )}
  </div>
);
